import { gql } from "apollo-boost"

export const deletedAccount = gql`
  mutation DeleteAccountFull(
    $id: ID!
  ){
    DeleteAccountFull(
      id: $id
    )
  }
`